import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setAuthorizationToken } from '../actions';
import { selectors } from '../reducer';
function useAuthorizationToken() {
    const dispatch = useDispatch();
    const location = useLocation();
    const authorizationToken = useSelector((state) => selectors.authorizationToken(state));
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const token = urlParams.get('token');
        if (token && !authorizationToken) {
            dispatch(setAuthorizationToken(token));
        }
    }, [location.search, authorizationToken, dispatch]);
    return authorizationToken;
}
export default useAuthorizationToken;
